export default {
  strict: true,
  namespaced: true,
  state: {
    location: {
      list: [],
      selected: null,
      loading: false
    },
    date: {
      show: false,
      start: null,
      end: null
    },
    sort: 'lowToHigh',
    list: [],
    categories: [],
    filter: {
      categories: []
    },
    view: null
  },
  mutations: {
    setThingsData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    setThingsLocationData (state, data) {
      for (let field in data) {
        state.location[field] = data[field]
      }
    },
    setThingsDateData (state, data) {
      for (let field in data) {
        state.date[field] = data[field]
      }
    },
    setThingsFilterData (state, data) {
      for (let field in data) {
        state.filter[field] = data[field]
      }
    },
    toggleFilterCategory (state, value) {
      let i = state.filter.categories.indexOf(value)
      if (i > -1) state.filter.categories.splice(i, 1)
      else state.filter.categories.push(value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/things-to-do/index.js